<template>
  <div class="products-container">
    <div class="products-lists-container" v-if="products.length > 0">
      <router-link
        tag="div"
        class="grid__item-product"
        v-for="(product, index) in products"
        :key="index"
        :to="`/product/${theme === 'collect-list' ? product.product_id : product.id}`"
        :class="{
          'scroll-up-to hoverEffect': theme !== 'manage' && theme !== 'collect-list',
          mangeHover: theme === 'manage',
        }"
      >
        <div class="item__manage" v-if="theme === 'manage'">
          <div class="manage__item" @click.stop="onEdit(product.id)">
            <i class="icon icon-manage-edit"></i>
          </div>
          <div class="manage__item" @click.stop="onDelete(product.id)">
            <i class="icon icon-manage-delete"></i>
          </div>
          <div class="manage__item" @click.stop="routergo(product.id)">
            <i class="icon icon-manage-preview"></i>
          </div>
        </div>

        <div class="item-product__cover">
          <img class="lazyload" :src="product.title_picture_url | parseImage" alt="" />
          <div class="cover__label">{{ product.mold_name }}·{{ product.mold_en_name }}</div>
        </div>
        <div class="item-product__info">
          <div class="info__name">{{ product.name }}</div>
          <div class="info__price">￥{{ product.min_price }} - ￥{{ product.max_price }}</div>
          <div class="info__provider-info">
            <div class="provider-info__head">
              <img :src="(storeLogo ? storeLogo : product.store_logo_url) | parseImage" alt="" />
            </div>
            <div class="provider-info__name">{{ product.store_name }}</div>
            <div class="provider-info__views">
              <i class="views__icon icon icon-view"></i>
              <p class="views__text">{{ product.browsenums }}</p>
            </div>
          </div>
        </div>
        <div class="item__manage" v-if="theme === 'collect-list'">
          <el-button class="yellow" @click.stop="addMlist(product.product_id)">移出清单</el-button>
          <el-button class="yellow" @click.stop="addCarts(product.product_id)">移入清单</el-button>
          <el-button class="black" @click.stop="onDelete(product.product_id)">删除</el-button>
        </div>
      </router-link>
    </div>
    <Empty hint="没有找到相关信息" v-else></Empty>
    <Pagination
      class="component-pagination"
      :config="isShowPagination"
      v-if="isShowPagination && products.length > 0"
    ></Pagination>
  </div>
</template>

<script>
import Pagination from "@/components/pagination.vue";
import Empty from "@/pages/common/empty.vue";

export default {
  components: {
    Pagination,
    Empty,
  },
  props: {
    products: {
      type: Array,
      default: () => [],
    },
    theme: {
      type: String,
      default: null,
    },
    isShowPagination: {
      type: Object,
      default: null,
    },
    storeLogo: {
      type: String,
      default: "",
    },
  },
  methods: {
    routergo(id) {
      this.$router.push({
        path: `/product/${id}`,
      });
    },
    onEdit(id) {
      this.$router.push({
        path: `/my/product/${id}`,
      });
    },
    addMlist(id) {
      this.$router.push({
        path: `/my/collects/products/${id}`,
      });
    },
    onDelete(id) {
      this.$emit("onDelete", id);
    },
    addCarts(id) {
      this.$emit("addCarts", id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_mixin";
.component-pagination {
  margin-top: px2vw(98 - 30);
}
.el-button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  padding: 5px 8px;
  font-size: 12px;
  border-radius: 4px;
}
.red {
  background-color: #ff0000;
  color: #ffffff;
}
.black {
  background-color: #000;
  color: #ffffff;
  margin-right: 18px;
}
.yellow {
  background-color: #fabe00;
  color: #ffffff;
  margin-right: 18px;
}
</style>
